<template>
  <div v-show="!(field.hide && field.hide())">
  <md-checkbox
    v-model="form[name]"
    :key="field.label + '_input'"
    class="labelColor"
    :class="[
                  { 'md-valid': !$vo[name].$invalid },
                  { 'md-error': $vo[name].$invalid }
                ]"
    :disabled="pageMode == 'view' || pageMode == 'assignee' || field.preventEdit"
    @change="$vo[name].$touch()"
  >{{ field.label }}</md-checkbox>
  </div>
</template>
<script>
  export default {
    name: "crud-checkbox",
    components: {},
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $vo: {
        type: Object,
        required: true
      },
    },
    data() {
      return {}
    },
  };
</script>